import { Form } from "@redriver/cinnamon-mui";
import { projectTypesLookup } from "modules/lookups";

const ProjectTypeDropdown = (props) => (
  <Form.Dropdown search lookup={projectTypesLookup} {...props} />
);

export default ProjectTypeDropdown;
